import { useContext } from 'react'

import { CartContext, useCartTotals } from '@lib/cart'
import { DiscountContext } from '@lib/discount'

import CartDiscount from './discount'
import CartSubtotal from './subtotal'
import CartTotal from './total'

interface CartSummaryProps {
  className?: string
}

const CartSummary = ({ className }: CartSummaryProps) => {
  const { subTotal, totalDiscount, total } = useCartTotals()
  const { cart } = useContext(CartContext)
  const { cartDiscountItems } = useContext(DiscountContext)

  const automaticDiscount = cart?.automaticDiscount ?? null

  return (
    <div className={className}>
      <CartSubtotal price={subTotal} />

      {automaticDiscount.amount > 0 && (
        <CartDiscount
          title={automaticDiscount.title}
          amount={automaticDiscount.amount}
          className="mt-3"
        />
      )}

      {cartDiscountItems?.map(({ id, title, amount, quantity }) => (
        <CartDiscount
          key={id}
          title={title}
          amount={amount}
          quantity={quantity}
          className="mt-3"
        />
      ))}

      <CartTotal price={total - totalDiscount} className="mt-3" />
    </div>
  )
}

export default CartSummary
